/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Legajox_Ingest_Approval_ApprovedInputs */

const es_components_legajox_ingest_approval_approved = /** @type {(inputs: Components_Legajox_Ingest_Approval_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingesta de Legajox aprobada`)
};

const en_components_legajox_ingest_approval_approved = /** @type {(inputs: Components_Legajox_Ingest_Approval_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legajox ingestion approved`)
};

/**
* | output |
* | --- |
* | "Legajox ingestion approved" |
*
* @param {Components_Legajox_Ingest_Approval_ApprovedInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_legajox_ingest_approval_approved = /** @type {((inputs?: Components_Legajox_Ingest_Approval_ApprovedInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Legajox_Ingest_Approval_ApprovedInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_legajox_ingest_approval_approved(inputs)
	return en_components_legajox_ingest_approval_approved(inputs)
});
export { components_legajox_ingest_approval_approved as "components.legajox_ingest_approval.approved" }